import { ScToast } from '@intelipost-js/secure-components';
import { GraphQlClient } from '@intelipost-js/secure-providers';

export default {
  getMargin({ commit }) {
    commit('toggleLoadingMargin', true);

    return GraphQlClient.query(`
      query {
        reconConfig {
          marginType
          marginFixedValue
          marginPercentageValue
          marginMixedFixedValue
          marginMixedPercentageValue
        }
      }`)
      .then(({ data }) => {
        const { reconConfig } = data || {};
        commit('setMargin', reconConfig);
        commit('toggleLoadingMargin', false);
      })
      .catch(() => commit('toggleLoadingMargin', false));
  },
  saveMargin({ commit, state }) {
    commit('toggleLoadingMarginSave', true);

    return GraphQlClient.mutation(`
      mutation (
        $marginType: String,
        $marginFixedValue: Float,
        $marginPercentageValue: Float,
        $marginMixedFixedValue: Float,
        $marginMixedPercentageValue: Float
      ) {
        reconConfig(
          marginType: $marginType,
          marginFixedValue: $marginFixedValue,
          marginPercentageValue: $marginPercentageValue,
          marginMixedFixedValue: $marginMixedFixedValue,
          marginMixedPercentageValue: $marginMixedPercentageValue
        ) {
          ok
        }
      }`, state.margin)
      .then(() => {
        commit('toggleLoadingMarginSave', false);
        ScToast.success('Margem de divergência salva com sucesso');
      })
      .catch(() => commit('toggleLoadingMarginSave', false));
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/configuration-invoice/store/actions.js